import * as React from "react";
import { Image, Pressable, StyleSheet, View } from "react-native";
import { ScrollView } from "react-native-gesture-handler";
import { Text, useTheme } from "react-native-paper";
import { Block } from "@block";
import { StackSpacing } from "@components/spacing";
import { useDesktopMediaQuery } from "@media-query";
import { StackActions, useNavigation } from "@react-navigation/native";
import { spacing } from "@styles/spacing";
import HeaderNav from "app/shared/components/header-nav/header-nav";
import ModalImage from "app/shared/components/modal/modal-image/modal-image";
import { NavTitleBar, SubtitleNavTitleBar } from "app/shared/components/nav-title-bar/nav-title-bar";
import ScreenNameType from "app/shared/constant/nav-screen.type";
import images from "app/shared/styles/images";
import { globalShowFuture } from "app/shared/util/future";
import { useTranslation } from "react-i18next";
import Modal from "react-modal";
import Animated, { useAnimatedStyle, withSpring } from "react-native-reanimated";
import userGuideJson from "../__test__/user-guide.json";

interface ItemAswQuesProps {
  vi: string;
  en: string;
}

type PressAbleState = Readonly<{
  pressed: boolean;
  hovered?: boolean;
  focused?: boolean;
}>;

const UserGuide = () => {
  const { colors, fonts } = useTheme();
  const { t, i18n } = useTranslation();
  const { dispatch } = useNavigation();
  const isDesktop = useDesktopMediaQuery();

  const [visibleModal, setVisibleModal] = React.useState(false);
  const [visibleIndex, setVisibleIndex] = React.useState(0);

  const onCancel = () => {
    dispatch(StackActions.replace(ScreenNameType.HOME));
  };

  const onGoBack = () => {
    dispatch(StackActions.replace(ScreenNameType.LIST_ABOUT_US));
  };

  const styles = React.useMemo(
    () =>
      StyleSheet.create({
        textName: { ...fonts.medium, color: colors.text, textAlign: "center", maxWidth: 164, alignSelf: "center" },
        modalStyle: { alignSelf: "center" },
        container: { flexDirection: "row", flexWrap: "wrap" },
        content: { maxWidth: isDesktop ? "25%" : "50%", minWidth: isDesktop ? "25%" : "50%" },
        pressAble: { alignSelf: "center" },
        imageStyle: { borderRadius: spacing.small, height: 90, width: 120 },
      }),
    [colors.text, fonts.medium, isDesktop],
  );

  const subtitlesArrays: Array<SubtitleNavTitleBar> = [
    {
      name: t("FUNC_TRANG_CHU"),
      onPressSubtitle: () => onCancel(),
    },
    {
      name: t("SETTING_PV_ONLINE_BANKING"),
      onPressSubtitle: () => onGoBack(),
    },
    {
      name: t("SETTING_HUONG_DAN_SU_DUNG"),
      onPressSubtitle: () => {},
    },
  ];

  const onPressItems = (index: number) => {
    setVisibleIndex(index);
    switch (index) {
      case 0:
        setVisibleModal(true);
        break;
      case 1:
        setVisibleModal(true);
        break;
      default:
        globalShowFuture();
        break;
    }
  };

  const handlerIconImage = (_index: number) => {
    if (_index === 0) {
      return images.otp_guild_mobile;
    } else if (_index === 1) {
      return images.report_guide_mobile;
    }
  };

  const handlerImage = () => {
    if (visibleIndex === 0) {
      return isDesktop ? images.otp_guide : images.otp_guild_mobile;
    } else if (visibleIndex === 1) {
      return isDesktop ? images.report_guide : images.report_guide_mobile;
    }
  };

  const renderModal = (
    <Modal
      ariaHideApp={false}
      style={{
        overlay: {
          backgroundColor: colors.backdrop,
        },
        content: {
          border: "none",
          background: "transparent",
          top: "50%",
          left: "50%",
          right: "auto",
          bottom: "auto",
          marginRight: "-50%",
          transform: "translate(-50%, -50%)",
        },
      }}
      isOpen={visibleModal}
      onRequestClose={() => setVisibleModal(false)}
      contentLabel="Modal Preview">
      <>
        <ModalImage
          onHideModal={() => setVisibleModal(false)}
          image={handlerImage()}
          imageRatio={isDesktop ? 1080 / 600 : 800 / 600}
          buttonTitle={t("COMMON_DONG")}
          onButton={() => setVisibleModal(false)}
        />
      </>
    </Modal>
  );

  return (
    <Block flex={1}>
      <ScrollView>
        <HeaderNav />
        <NavTitleBar title={t("SETTING_HUONG_DAN_SU_DUNG")} subtitles={subtitlesArrays} />
        <Block pv={spacing.medium} ph={isDesktop ? "5%" : 0}>
          <View style={styles.container}>
            {userGuideJson.funcitons[0].children.map((_item, _index) => (
              <View key={_index} style={styles.content}>
                <Pressable style={styles.pressAble} onPress={() => onPressItems(_index)} key={_index}>
                  {({ hovered }: PressAbleState) => {
                    // eslint-disable-next-line react-hooks/rules-of-hooks
                    const _buttonStyle = useAnimatedStyle(() => {
                      return {
                        justifyContent: "center",
                        alignItems: "center",
                        transform: [
                          {
                            scale: hovered ? withSpring(1.06) : withSpring(1),
                          },
                        ],
                      };
                    });
                    return (
                      <Animated.View style={_buttonStyle}>
                        <Block br={spacing.small} bg={colors.backgroundForm} middle center>
                          <Image style={styles.imageStyle} source={handlerIconImage(_index)} />
                        </Block>
                        <StackSpacing size="small" />
                        <Text numberOfLines={2} style={styles.textName}>
                          {i18n.language === "vi" ? _item.name.vi : _item.name.en}
                        </Text>
                        <StackSpacing size="huge" />
                      </Animated.View>
                    );
                  }}
                </Pressable>
              </View>
            ))}
          </View>
        </Block>
      </ScrollView>
      {renderModal}
    </Block>
  );
};

export default UserGuide;
